import React, {
  useState,
  useEffect,
  useImperativeHandle,
  useRef,
  forwardRef,
} from "react";
import {
  Box,
  TextField,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Typography,
  MenuItem,
  Button,
  Skeleton,
  TableCell,
  TableRow,
  Table,
  TableBody,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import SnackbarAlert from "../SnackbarAlert";
import nucleusxp from "nucleusxp";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExpandLess from "@mui/icons-material/ExpandLess";
const Equipment = forwardRef(
  ({ formData, handleChange, highlighted = false }, ref) => {
    const [equipmentList, setEquipmentList] = useState([]);
    const [equipTypes, setEquipTypes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [expandedIndex, setExpandedIndex] = useState(0);
    const [selectedEquipment, setSelectedEquipment] = useState(null);
    const [snackbar, setSnackbar] = useState({
      open: false,
      severity: "error",
      message: "",
    });
    const textFieldRef = useRef();
    useImperativeHandle(ref, () => ({
      scrollToField: () => {
        textFieldRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      },
    }));
    useEffect(() => {
      const fetchBaseData = async () => {
        setLoading(true);
        const equipData = await nucleusxp.healthSafety.getEquipmentTypes();
        setEquipTypes(equipData.items ?? []);
        setLoading(false);
      };
      fetchBaseData();
    }, []);
    useEffect(() => {
      if (
        Array.isArray(formData.equipmentList) &&
        formData.equipmentList.length > 0
      ) {
        setEquipmentList(formData.equipmentList);
      }
    }, [formData.equipmentList, setEquipmentList]);

    const handleClose = (event, reason) => {
      if (reason === "clickaway") return;
      setSnackbar({ ...snackbar, open: false });
    };

    const handleAddEquipment = () => {
      if (!formData.equipmentName) {
        setSnackbar({
          open: true,
          severity: "error",
          message: "Please check name of equipment field",
        });
        return;
      }
      if (!formData.equipmentDescription) {
        setSnackbar({
          open: true,
          severity: "error",
          message: "Please check Description of Damage field",
        });
        return;
      }
      const newData = {
        barcode: formData.barcode || "",
        type: formData.equipmentType || "",
        name: formData.equipmentName || "",
        id: formData.equipmentId || "",
        color: formData.equipmentColor || "",
        description: formData.equipmentDescription || "",
      };
      setEquipmentList((prev) => {
        const updatedList = [...prev, newData];
        formData.equipmentList = updatedList;
        return updatedList;
      });
      if (formData.equipmentList.length === 1) {
        setSelectedEquipment(newData);
      }
      formData.barcode = "";
      formData.equipmentType = "";
      formData.equipmentName = "";
      formData.equipmentId = "";
      formData.equipmentColor = "";
      formData.equipmentDescription = "";

      // handleChange({ target: { name: "barcode", value: "" } });
      // handleChange({ target: { name: "equipmentType", value: "" } });
      // handleChange({ target: { name: "equipmentName", value: "" } });
      // handleChange({ target: { name: "equipmentId", value: "" } });
      // handleChange({ target: { name: "equipmentColor", value: "" } });
      // handleChange({ target: { name: "equipmentDescription", value: "" } });
    };

    const handleRemoveItem = (index) => {
      setEquipmentList((prev) => prev.filter((_, i) => i !== index));
    };

    const handleScanBarcode = () => {
      // After scanning, update formData with the scanned barcode value
      handleChange({
        target: { name: "barcode", value: "scannedBarcodeValue" },
      });
    };

    const handleListItemClick = (item, index) => {
      if (expandedIndex === index) {
        setExpandedIndex(null);
        setSelectedEquipment(null);
      } else {
        setExpandedIndex(index);
        setSelectedEquipment(item);
      }
    };

    return (
      <div
        ref={textFieldRef}
        name="equipmentList"
        style={{ border: highlighted ? "2px solid #1976d2" : "none" }}
      >
        <Box>
          <Typography variant="body2" sx={{ color: "#888", marginTop: "10px" }}>
            Equipment Damages
          </Typography>
          <Button
            variant="outlined"
            color="primary"
            fullWidth
            onClick={handleScanBarcode}
            sx={{ marginBottom: "16px" }}
          >
            Scan Barcode
          </Button>
          <Box>
            {!loading ? (
              <TextField
                fullWidth
                margin="normal"
                label="Type of Equipment"
                name="equipmentType"
                select
                value={formData.equipmentType || ""}
                onChange={handleChange}
              >
                {equipTypes.map((equip) => (
                  <MenuItem value={equip.id} key={equip.id}>
                    {equip.name}
                  </MenuItem>
                ))}
              </TextField>
            ) : (
              <Skeleton variant="rectangular" width={350} height={30} />
            )}
          </Box>

          <TextField
            fullWidth
            margin="normal"
            label="Name of Equipment"
            name="equipmentName"
            value={formData.equipmentName || ""}
            onChange={handleChange}
          />
          <TextField
            fullWidth
            margin="normal"
            label="ID"
            name="equipmentId"
            value={formData.equipmentId || ""}
            onChange={handleChange}
          />
          <TextField
            fullWidth
            margin="normal"
            label="Color"
            name="equipmentColor"
            value={formData.equipmentColor || ""}
            onChange={handleChange}
          />
          <TextField
            fullWidth
            margin="normal"
            label="Description of Damage"
            name="equipmentDescription"
            value={formData.equipmentDescription || ""}
            onChange={handleChange}
          />
          <IconButton onClick={handleAddEquipment} color="primary">
            <AddIcon />
          </IconButton>

          <List>
            {equipmentList.map((item, index) => (
              <ListItem
                key={index}
                onClick={() =>
                  // setExpandedIndex((prevIndex) =>
                  //   prevIndex === index ? prevIndex : index,
                  // )
                  handleListItemClick(item, index)
                }
                sx={{
                  backgroundColor:
                    expandedIndex === index ? "lightblue" : "white",
                  cursor: "pointer",
                  border:
                    expandedIndex === index ? "2px solid #007BFF" : "none",
                  "&:hover": {
                    backgroundColor:
                      expandedIndex === index ? "lightblue" : "#f5f5f5",
                  },
                }}
              >
                <ListItemText primary={`${item.name} - ${item.description}`} />
                <IconButton sx={{ marginLeft: "auto" }}>
                  {expandedIndex === index ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
                <ListItemSecondaryAction>
                  <IconButton
                    edge="end"
                    onClick={() => handleRemoveItem(index)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
          {selectedEquipment && (
            <Box sx={{ marginTop: "20px" }}>
              <Typography variant="h6">Selected Equipment Details</Typography>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell>Type</TableCell>
                    <TableCell>
                      {
                        equipTypes.find(
                          (equip) => equip.id === selectedEquipment.type,
                        ).name
                      }
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>{selectedEquipment.name || "N/A"}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>{selectedEquipment.id || "N/A"}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Color</TableCell>
                    <TableCell>{selectedEquipment.color || "N/A"}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Description</TableCell>
                    <TableCell>
                      {selectedEquipment.description || "N/A"}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          )}
          <SnackbarAlert
            open={snackbar.open}
            onClose={handleClose}
            severity={snackbar.severity}
            message={snackbar.message}
          />
        </Box>
      </div>
    );
  },
);

export default Equipment;
